import React from 'react';
import PropTypes from 'prop-types';
import { IconButton } from 'office-ui-fabric-react/lib/Button';
import { isEmpty } from 'lodash';
import FormikTypeaheadPicker from '../TypeaheadPicker/FormikTypeaheadPicker';

const createSuggestionForProduct = product => ({
  icon: 'Tag',
  header: 'Products',
  key: product.tokenId,
  text: product.name,
  secondaryLabel: product.tokenId,
  href: `/products/${product.tokenId}`,
});

const createSuggestionForPfam = pfam => {
  return {
    icon: 'Tag',
    header: 'Product Family',
    key: pfam.pfamCode,
    text: pfam.productFamilyName,
    secondaryLabel: pfam.pfamCode,
  };
};

const ProductAutosuggest = ({
  field,
  form,
  className,
  excludeProducts,
  hideSuggestions,
  onChange,
  enablePfams,
  ...other
}) => {
  const resourceTransformers = {
    products: createSuggestionForProduct,
    pfams: createSuggestionForPfam,
  };

  const resources = ['products'];
  if (enablePfams) resources.push('pfams', 'productsWithPfams');

  return (
    <FormikTypeaheadPicker
      field={field}
      form={form}
      searchResources={resources}
      resourceTransformers={resourceTransformers}
      showErrors
      noDropdownButton
      textFieldProps={{
        onRenderSuffix: () =>
          !isEmpty(field.value) && (
            <IconButton
              iconProps={{ iconName: 'Cancel' }}
              ariaLabel="Clear"
              onClick={() => form.setFieldValue(field.name, {})}
            />
          ),
      }}
      placeholder="Search by product name or product ID"
      {...other}
    />
  );
};

ProductAutosuggest.propTypes = {
  field: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.any,
  }),
  form: PropTypes.shape({
    errors: PropTypes.shape({}),
    setFieldValue: PropTypes.func.isRequired,
  }),
  className: PropTypes.string,
  excludeProducts: PropTypes.arrayOf(
    PropTypes.shape({
      tokenId: PropTypes.number.isRequired,
    }),
  ),
  onChange: PropTypes.func,
  hideSuggestions: PropTypes.bool,
  enablePfams: PropTypes.bool,
};

ProductAutosuggest.defaultProps = {
  form: { errors: {} },
  field: { name: '', value: undefined },
  className: '',
  excludeProducts: undefined,
  onChange: () => {},
  hideSuggestions: false,
  enablePfams: false,
};
export default ProductAutosuggest;
